export enum BranchMinimumCartSystemValueType {
  PER_DIRECT_DISTANCE = 'PerDirectDistance',
  PER_DIRECT_DISTANCE_SEGMENT = 'PerDirectDistanceSegment'
}
